/* eslint-disable react/prop-types */
// @ts-check;
import React, { useEffect } from 'react';
import { Form, Row, Col, Divider, Select, Checkbox } from 'antd';
import { Input } from 'components/gyramais';
import { formatAndNotificateError, formatString } from 'utils';

import AddressForm from './components/BadesulAddress';
import { selectSearcher } from 'utils/select';
import { useMutation } from '@apollo/client';

import BadesulSocietyForm from '../BadesulMicrocreditoBusinessUserDrawer/components/BadesulSocietyForm';

import { SAVE_BUSINESS } from '../../graphql';

import './styles.less';

const { Option } = Select;

const { Item } = Form;

/**
 * @type {{
 *  name:string;
 *  value:string;
 *  requiredMessage?:string;
 *  maskType?: "cnpj" | "phone";
 *  type?:"currency";
 *  size: "small" | "normal" | "large"; // small(30%) normal(70%) large(100%)
 *  options: string[] | { name: string, value: string }[];
 * }[]}
 */
const inputs = [
  {
    name: 'CNPJ',
    value: 'cnpj',
    size: 'small',
    maskType: 'cnpj',
    disabled: true,
  },
  {
    size: 'normal',
    name: 'Nome fantasia',
    value: 'name',
  },
  {
    size: 'normal',
    name: 'Razão Social',
    value: 'legalName',
  },
  {
    name: 'Contato',
    maskType: 'phone',
    value: 'phoneNumber',
    size: 'small',
  },
  {
    name: 'Capital Social',
    value: 'socialCapital',
    size: 'small',
    type: 'currency',
  },
  {
    size: 'normal',
    name: 'Tipo de capital',
    value: 'capitalType',
    options: [
      {
        name: 'Nacional Sem Participação Estrangeira',
        value: 'NACIONAL_SEM_PARTICIPACAO_ESTRANGEIRA',
      },
      {
        name: 'Nacional com Participação Estrangeira',
        value: 'NACIONAL_COM_PARTICIPACAO_ESTRANGEIRA',
      },
      {
        name: 'Nacional com participação estrangeira superior ou igual a 50% capital votante',
        value: 'NAC_COM_PART_ESTR_SUPERIOR_IGUAL_50_CAP_VOTANTE',
      },
      {
        name: 'Nacional com participação estrangeira inferior a 50% capital votante',
        value: 'NAC_COM_PART_ESTR_INFERIOR_50_CAP_VOTANTE',
      },
    ],
  },
  {
    size: 'large',
    name: 'Natureza Jurídica',
    value: 'legalNature',
    options: [
      { value: '399-9', name: 'Associação Privada' },
      { value: '111-2', name: 'Autarquia Estadual ou do Distrito Federal' },
      { value: '110-4', name: 'Autarquia Federal' },
      { value: '112-0', name: 'Autarquia Municipal' },
      { value: '409-0', name: 'Candidato a Cargo Político Eletivo' },
      { value: '222-4', name: 'Clube/Fundo de Investimento' },
      { value: '310-7', name: 'Comissão de Conciliação Prévia' },
      { value: '119-8', name: 'Comissão Polinacional' },
      { value: '328-0', name: 'Comitê Financeiro de Partido Político' },
      { value: '323-9', name: 'Comunidade Indígena' },
      { value: '308-5', name: 'Condomínio Edilício' },
      { value: '228-3', name: 'Consórcio de Empregadores' },
      { value: '215-1', name: 'Consórcio de Sociedades' },
      { value: '122-8', name: 'Consórcio Público de Direito Privado' },
      {
        value: '121-0',
        name: 'Consórcio Público de Direito Público (Associação Pública)',
      },
      { value: '229-1', name: 'Consórcio Simples' },
      { value: '408-1', name: 'Contribuinte Individual' },
      { value: '214-3', name: 'Cooperativa' },
      { value: '233-0', name: 'Cooperativas de Consumo' },
      { value: '331-0', name: 'Demais Condomínios' },
      { value: '227-5', name: 'Empresa Binacional' },
      { value: '221-6', name: 'Empresa Domiciliada no Exterior' },
      {
        value: '230-5',
        name: 'Empresa Individual de Responsabilidade Limitada (de Natureza Empresária)',
      },
      {
        value: '231-3',
        name: 'Empresa Individual de Responsabilidade Limitada (de Natureza Simples)',
      },
      { value: '401-4', name: 'Empresa Individual Imobiliária' },
      { value: '201-1', name: 'Empresa Pública' },
      {
        value: '234-8',
        name: 'Empresa Simples de Inovação - Inova Simples',
      },
      { value: '213-5', name: 'Empresário (Individual)' },
      { value: '311-5', name: 'Entidade de Mediação e Arbitragem' },
      { value: '313-1', name: 'Entidade Sindical' },
      {
        value: '219-4',
        name: 'Estabelecimento, no Brasil, de Empresa Binacional Argentino-Brasileira',
      },
      {
        value: '320-4',
        name: 'Estabelecimento, no Brasil, de Fundação ou Associação Estrangeiras',
      },
      {
        value: '217-8',
        name: 'Estabelecimento, no Brasil, de Sociedade Estrangeira',
      },
      { value: '123-6', name: 'Estado ou Distrito Federal' },
      { value: '329-8', name: 'Frente Plebiscitária ou Referendária' },
      {
        value: '321-2',
        name: 'Fundação ou Associação domiciliada no exterior',
      },
      { value: '306-9', name: 'Fundação Privada' },
      {
        value: '126-0',
        name: 'Fundação Pública de Direito Privado Estadual ou do Distrito Federal',
      },
      {
        value: '125-2',
        name: 'Fundação Pública de Direito Privado Federal',
      },
      {
        value: '127-9',
        name: 'Fundação Pública de Direito Privado Municipal',
      },
      {
        value: '114-7',
        name: 'Fundação Pública de Direito Público Estadual ou do Distrito Federal',
      },
      {
        value: '113-9',
        name: 'Fundação Pública de Direito Público Federal',
      },
      {
        value: '115-5',
        name: 'Fundação Pública de Direito Público Municipal',
      },
      { value: '324-7', name: 'Fundo Privado' },
      { value: '120-1', name: 'Fundo Público' },
      {
        value: '132-5',
        name: 'Fundo Público da Administração Direta Estadual ou do Distrito Federal',
      },
      {
        value: '131-7',
        name: 'Fundo Público da Administração Direta Federal',
      },
      {
        value: '133-3',
        name: 'Fundo Público da Administração Direta Municipal',
      },
      {
        value: '129-5',
        name: 'Fundo Público da Administração Indireta Estadual ou do Distrito Federal',
      },
      {
        value: '128-7',
        name: 'Fundo Público da Administração Indireta Federal',
      },
      {
        value: '130-9',
        name: 'Fundo Público da Administração Indireta Municipal',
      },
      { value: '216-0', name: 'Grupo de Sociedades' },
      { value: '235-6', name: 'Investidor Não Residente' },
      { value: '411-1', name: 'Leiloeiro' },
      { value: '124-4', name: 'Município' },
      { value: '501-0', name: 'Organização Internacional' },
      { value: '322-0', name: 'Organização Religiosa' },
      { value: '330-1', name: 'Organização Social (OS)' },
      {
        value: '327-1',
        name: 'Órgão de Direção Local de Partido Político',
      },
      {
        value: '325-5',
        name: 'Órgão de Direção Nacional de Partido Político',
      },
      {
        value: '326-3',
        name: 'Órgão de Direção Regional de Partido Político',
      },
      {
        value: '117-1',
        name: 'Órgão Público Autônomo Estadual ou do Distrito Federal',
      },
      { value: '116-3', name: 'Órgão Público Autônomo Federal' },
      { value: '118-0', name: 'Órgão Público Autônomo Municipal' },
      {
        value: '102-3',
        name: 'Órgão Público do Poder Executivo Estadual ou do Distrito Federal',
      },
      { value: '101-5', name: 'Órgão Público do Poder Executivo Federal' },
      {
        value: '103-1',
        name: 'Órgão Público do Poder Executivo Municipal',
      },
      {
        value: '108-2',
        name: 'Órgão Público do Poder Judiciário Estadual',
      },
      { value: '107-4', name: 'Órgão Público do Poder Judiciário Federal' },
      {
        value: '105-8',
        name: 'Órgão Público do Poder Legislativo Estadual ou do Distrito Federal',
      },
      {
        value: '104-0',
        name: 'Órgão Público do Poder Legislativo Federal',
      },
      {
        value: '106-6',
        name: 'Órgão Público do Poder Legislativo Municipal',
      },
      { value: '503-7', name: 'Outras Instituições Extraterritoriais' },
      { value: '312-3', name: 'Partido Político' },
      {
        value: '332-8',
        name: 'Plano de Benefícios de Previdência Complementar Fechada',
      },
      { value: '412-0', name: 'Produtor Rural (Pessoa Física)' },
      { value: '502-9', name: 'Representação Diplomática Estrangeira' },
      { value: '402-2', name: 'Segurado Especial' },
      { value: '303-4', name: 'Serviço Notarial e Registral (Cartório)' },
      { value: '307-7', name: 'Serviço Social Autônomo' },
      { value: '204-6', name: 'Sociedade Anônima Aberta' },
      { value: '205-4', name: 'Sociedade Anônima Fechada' },
      { value: '203-8', name: 'Sociedade de Economia Mista' },
      { value: '212-7', name: 'Sociedade em Conta de Participação' },
      {
        value: '209-7',
        name: 'Sociedade Empresária em Comandita por Ações',
      },
      { value: '208-9', name: 'Sociedade Empresária em Comandita Simples' },
      { value: '207-0', name: 'Sociedade Empresária em Nome Coletivo' },
      { value: '206-2', name: 'Sociedade Empresária Limitada' },
      { value: '226-7', name: 'Sociedade Simples em Comandita Simples' },
      { value: '225-9', name: 'Sociedade Simples em Nome Coletivo' },
      { value: '224-0', name: 'Sociedade Simples Limitada' },
      { value: '223-2', name: 'Sociedade Simples Pura' },
      { value: '232-1', name: 'Sociedade Unipessoal de Advogados' },
      { value: '134-1', name: 'União' },
    ],
  },
  {
    size: 'normal',
    name: 'Ramo de Atividade',
    value: 'activityBranch',
    options: ['Indústria', 'Comércio', 'Serviço'],
  },
  {
    size: 'small',
    name: 'Tipo de Regime Fiscal',
    value: 'taxRegime',
    options: [
      {
        name: 'Lucro Real',
        value: 'LUCRO_REAL',
      },
      {
        name: 'Lucro Presumido',
        value: 'LUCRO_PRESUMIDO',
      },
      {
        name: 'Simples Nacional',
        value: 'SIMPLES_NACIONAL',
      },
    ],
  },
];

const sizeMap = {
  small: {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 8,
  },
  normal: {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 16,
  },
  large: {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 24,
  },
};

const BadesulMicrocreditoBusinessForm = ({ business, address, form, flow }) => {
  const [hasOtherBusinessParticipation, setHasOtherBusinessParticipation] = React.useState(false);
  useEffect(() => {
    if (!business.id) {
      return;
    }
    const formObj = { id: business.id };

    const inputKeys = inputs.map((input) => input.value);

    inputKeys.push('hasOtherBusinessParticipation');

    for (const inputKey of inputKeys) {
      let value = business[inputKey] ?? business.additionalInfo?.[inputKey];

      if (inputKey === 'cnpj') {
        value = formatString(value, 'cnpj');
      }
      if (inputKey === 'phoneNumber') {
        value = formatString(value, 'phone');
      }

      formObj[inputKey] = value;
    }

    if (!formObj.legalNature) {
      formObj.legalNature = '213-5';
    }

    setHasOtherBusinessParticipation(business?.additionalInfo?.hasOtherBusinessParticipation);
    formObj.hasOtherBusinessParticipation =
      !!business?.additionalInfo?.hasOtherBusinessParticipation;

    form.setFieldsValue(formObj);
  }, [business?.id]);

  const [saveBusiness] = useMutation(SAVE_BUSINESS, {
    onError: (error) => formatAndNotificateError(error),
  });

  return (
    <Form layout="vertical" form={form} id="badesul-microcredito-business-form">
      <Row wrap gutter={12}>
        {inputs.map((input) => (
          <Col {...sizeMap[input.size]}>
            <Item
              name={input.value}
              label={input.name}
              rules={[
                {
                  required: true,
                  message: `Por favor preencha o campo ${input.name.toLowerCase()}.`,
                },
              ]}
            >
              {input.options ? (
                <Select
                  className="gyramais-input"
                  placeholder={input.name}
                  showSearch
                  filterOption={selectSearcher}
                >
                  {input.options.map((option) => {
                    const optionName = option.name ?? option;
                    const optionValue = option.value ?? option;

                    return (
                      <Option value={optionValue} label={optionName}>
                        {optionName}
                      </Option>
                    );
                  })}
                </Select>
              ) : (
                <Input
                  type={input.maskType ? 'masked' : input.type}
                  disabled={input.disabled}
                  className="ant-input"
                  guide
                  mask={input.maskType}
                  placeholder={input.name}
                />
              )}
            </Item>
          </Col>
        ))}

        <Divider className="divider-without-margin" />

        <AddressForm
          address={address}
          form={form}
          flow={flow}
          onlyColumns
          fieldProps={{
            postalCode: {
              fieldOrder: 1,
              lg: 7,
              md: 12,
              xs: 24,
            },
            street: {
              fieldOrder: 2,
              lg: 11,
              md: 12,
              xs: 24,
            },
            district: {
              fieldOrder: 3,
              lg: 6,
              md: 12,
              xs: 24,
            },
            number: {
              fieldOrder: 4,
              lg: 5,
              md: 12,
              xs: 24,
            },
            complement: {
              fieldOrder: 5,
              lg: 7,
              md: 12,
              xs: 24,
            },
            state: {
              fieldOrder: 6,
              lg: 6,
              md: 12,
              xs: 24,
            },
            city: {
              fieldOrder: 7,
              lg: 6,
              md: 12,
              xs: 24,
            },
          }}
          business
          withLabel
        />

        <Divider className="divider-without-margin" />
        <Col xs={24} sm={24} md={24} lg={24}>
          <Item name="hasOtherBusinessParticipation">
            <Checkbox
              checked={hasOtherBusinessParticipation}
              onChange={(e) => {
                setHasOtherBusinessParticipation(e.target.checked);
                form.setFieldsValue({ hasOtherBusinessParticipation: e.target.checked });
              }}
            >
              Possui participação societária em outras empresas
            </Checkbox>
          </Item>
        </Col>

        {hasOtherBusinessParticipation && (
          <BadesulSocietyForm
            saveSocietyMutation={{
              mutation: saveBusiness,
              baseVariables: () => ({ id: business.id }),
            }}
            societyData={business?.additionalInfo?.societyData}
          />
        )}
      </Row>
    </Form>
  );
};

export default BadesulMicrocreditoBusinessForm;
export { inputs };
